import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook to manage focus on route changes for accessibility.
 * Moves focus to the main content area when navigating to a new page.
 */
export const useFocusManagement = () => {
  const location = useLocation();
  const mainContentRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // Small delay to ensure DOM is updated
    const timer = setTimeout(() => {
      const mainContent = document.querySelector("main");
      if (mainContent) {
        mainContentRef.current = mainContent as HTMLElement;
        // Set tabindex to make it focusable
        if (!mainContent.hasAttribute("tabindex")) {
          mainContent.setAttribute("tabindex", "-1");
        }
        mainContent.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return mainContentRef;
};
